import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import { Box, Button, useTheme } from '@mui/material'

import api from '../../service/api'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'
import { getCountString, Icons } from '../../utils/utilities'
import { useUserStore } from '../../store/user.store'


const AuditSimbaAi = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"
    const stats = searchParams.get( 'stats' ) || ""

    const [error, setError] = useState( null )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )

    const { layout } = useTheme()

    const UserStore = useUserStore()

    const countCards = [
        {
            icon: Icons.default.QuizIcon,
            label: "Practice Sessions",
            value: getCountString( counts.totalCounts?.practiceSessions || 0 ),
            secondary: getCountString( counts.last30daysCounts?.practiceSessions || 0 ),
            secondaryLabel: "In last 30 days"
        },
        {
            icon: Icons.default.Group,
            label: "Practice Attempts",
            value: getCountString( counts.totalCounts?.attempts || 0 ),
            secondary: getCountString( counts.last30daysCounts?.attempts || 0 ),
            secondaryLabel: "In last 30 days"
        }, {
            icon: Icons.default.Category,
            label: "Topics",
            value: getCountString( counts.totalCounts?.topics || 0 ),
            secondary: getCountString( counts.last30daysCounts?.topics || 0 ),
            secondaryLabel: "In last 30 days"
        },
        {
            icon: Icons.default.SupervisedUserCircle,
            label: "Faculty Members",
            value: getCountString( counts.totalCounts?.facultyMembers || 0 ),
            secondary: getCountString( counts.last30daysCounts?.facultyMembers || 0 ),
            secondaryLabel: "In last 30 days"
        },
        {
            icon: Icons.default.Group,
            label: "Students",
            value: getCountString( counts.totalCounts?.students || 0 ),
            secondary: getCountString( counts.last30daysCounts?.students || 0 ),
            secondaryLabel: "In last 30 days"
        },
    ]
    if ( selectedInstitute === "all" && ["ADMIN", "SUBADMIN"].includes( UserStore.getUser.user_role?.toUpperCase() ) )
        countCards.push( {
            icon: Icons.default.School,
            label: "Most active institute",
            value: counts.totalCounts?.instituteWiseCounts?.reduce( ( acc, item ) => item.count > acc.count ? item : acc, { institute: "", count: 0 } )?.institute || "",
            secondary: counts.last30daysCounts?.instituteWiseCounts?.reduce( ( acc, item ) => item.count > acc.count ? item : acc, { institute: "", count: 0 } )?.institute || "",
            secondaryLabel: "In last 30 days"
        } )

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const department = selectedDepartment !== "all" ? selectedDepartment : ""
            const institute = selectedInstitute !== "all" ? selectedInstitute : ""
            const { data: { data: counts } } = await api.audit.getPracticeSessionsCounts( { last30dayscount: true, institute, department } )

            setCounts( counts )
            setError( null )
        } catch ( err ) {
            setError( { message: err?.response?.data?.message || "Something went wrong while fetching the practice sessions audit data.", code: err?.response?.code } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute, selectedDepartment] )

    useEffect( () => {
        getData()
    }, [getData] )



    return (
        <Box padding={layout.pagePadding} display="flex" flexDirection="column" gap={layout.sectionsGap} overflow="auto" flexGrow={1}>

            {/* Header */}
            <AuditPageHeader
                loading={loading}
                title="Practice sessions with Simba"
                subtitle="View all simaba AI resources here."
                countCards={countCards}
                noDepartment={stats === 'student'}
            />

            {error && <Box sx={{ padding: "20px", flexShrink: 0 }}>
                <TryAgainMessageBlock getData={getData} err={error.message} code={error.code} loading={loading} />
            </Box>}
            <Outlet />
        </Box >
    )
}

export default AuditSimbaAi
